var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { HostService } from "@ane/core/lib/services/HostService";
import { onError } from "@ane/core/lib/decorators/OnError";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import EnvironmentService, { defaultTreatmentVariables } from "@ane/core/lib/services/EnvironmentService";
import graphService from "@ane/core/lib/services/GraphService";
import UsersResource from "./UserResources.js";
import "../utils/ManagementGroup/index.js";
import ___default from "lodash";
import { ANE_GROUP_ID } from "../tas/AnEGroup.constants.js";
import { TASService } from "../tas/TASService.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import * as CollectionUtils from "@ane/core/lib/utils/CollectionUtils";
import HostResource from "./Host.resource.js";
import { expAdapterService } from "../services/middlewares/ExpAdapterMiddleware.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { getManagementGroupLevels } from "../utils/ManagementGroup/ManagementGroup.utils.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let TreatmentAssignmentResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/users/");
    __publicField(this, "ALIAS_EMAIL_SUFFIX", "@microsoft.com");
    __publicField(this, "CHECK_GROUP_TIMEOUT_IN_MS", 1e3);
    __publicField(this, "USER_OID_EXP_PARAMS_HEADER_KEY", "oid");
    __publicField(this, "USER_OPERATIONID_EXP_PARAMS_HEADER_KEY", "operationid");
    __publicField(this, "IS_ANE_TEAM_ONLY_EXP_PARAMS_HEADER_KEY", "IsAneTeamOnly");
    __publicField(this, "WORKSPACEID_KEY", "workspaceid");
    __publicField(this, "CT_MANAGEMENTGROUP_LEVEL1_EXP_PARAMS_HEADER_KEY", "CTManagementGroupLevel1");
    __publicField(this, "CT_MANAGEMENTGROUP_LEVEL2_EXP_PARAMS_HEADER_KEY", "CTManagementGroupLevel2");
    __publicField(this, "CT_MANAGEMENTGROUP_LEVEL3_EXP_PARAMS_HEADER_KEY", "CTManagementGroupLevel3");
    // https://dev.azure.com/experimentation/Analysis%20and%20Experimentation/_wiki/wikis/AnE.wiki/5572/FAQ?anchor=setting-up-treatment-assignment-for-expux&_a=edit
    __publicField(this, "EXP_PARAMS_HEADER_KEY", "X-exp-parameters");
    __publicField(this, "SDK_VERSION_HEADER_KEY", "X-ExP-SDK-Version");
    __publicField(this, "SDK_VERSION_HEADER_VALUE", "Microsoft.VariantAssignment.Client/1.0.0");
    __publicField(this, "CHECK_MANAGEMENT_GROUP_TIMEOUT_IN_MS", 1e3);
    __publicField(this, "getExpUxAssignmentContext", (successData) => {
      var _a;
      return CollectionUtils.mapIfDefined(
        (_a = successData == null ? void 0 : successData.AssignmentContext) == null ? void 0 : _a.split(";"),
        (ac) => ac.toLowerCase().indexOf("expux") == 0 ? ac : void 0
      );
    });
  }
  getTreatmentAssignment(userOid, userAlias, workspaceId, operationId, logger) {
    return __async(this, null, function* () {
      const address = "https://default.exp-tas.com/exptas74/eecba607-edb2-4774-bced-ac5e1808e489-exponexptempux/api/v1/tas";
      const isAneTeamMember = yield this.isGroupMember(userAlias, logger);
      logger.setIsUserAnEOnly(isAneTeamMember);
      const headers = this.getHeaders({
        userOid,
        operationId,
        isAneTeamMember,
        managementGroupLevels: yield this.getManagementGroupHeaders(userAlias, workspaceId, logger),
        workspaceId
      });
      logger == null ? void 0 : logger.log(`[TreatmentAssignment] headers: ${JSON.stringify(headers)}`);
      const result = yield this._get(address, void 0, headers);
      logger == null ? void 0 : logger.log(`[TreatmentAssignment] Error : ${result.error}`);
      const successData = result.isSuccessful() ? result.getSuccessData() : void 0;
      const treatmentVariables = ___default.find((successData == null ? void 0 : successData.Configs) || [], (c) => c.Id === "TryExP") || {
        Id: "TryExP",
        Parameters: defaultTreatmentVariables
      };
      const expUxAssignmentContext = this.getExpUxAssignmentContext(successData);
      Logger.setAndLogTreatmentAssignmentResult({
        successfulCall: successData !== void 0,
        treatmentVariables: treatmentVariables == null ? void 0 : treatmentVariables.Parameters,
        expUxAssignmentContext
      });
      return treatmentVariables;
    });
  }
  getHeaders(values) {
    var _a, _b, _c, _d, _e, _f;
    const expParams = [];
    const getNameValuePair = (name, value) => `${name}=${value}`;
    expParams.push(getNameValuePair(this.USER_OID_EXP_PARAMS_HEADER_KEY, values.userOid));
    expParams.push(getNameValuePair(this.USER_OPERATIONID_EXP_PARAMS_HEADER_KEY, values.operationId));
    expParams.push(getNameValuePair(this.IS_ANE_TEAM_ONLY_EXP_PARAMS_HEADER_KEY, values.isAneTeamMember ? "1" : "0"));
    if (!!((_a = values.managementGroupLevels) == null ? void 0 : _a.level1)) {
      expParams.push(
        getNameValuePair(this.CT_MANAGEMENTGROUP_LEVEL1_EXP_PARAMS_HEADER_KEY, (_b = values.managementGroupLevels) == null ? void 0 : _b.level1)
      );
    }
    if (!!((_c = values.managementGroupLevels) == null ? void 0 : _c.level2)) {
      expParams.push(
        getNameValuePair(
          this.CT_MANAGEMENTGROUP_LEVEL2_EXP_PARAMS_HEADER_KEY,
          this.removeInvalidCharacter((_d = values.managementGroupLevels) == null ? void 0 : _d.level2)
        )
      );
    }
    if (!!((_e = values.managementGroupLevels) == null ? void 0 : _e.level3)) {
      expParams.push(
        getNameValuePair(
          this.CT_MANAGEMENTGROUP_LEVEL3_EXP_PARAMS_HEADER_KEY,
          this.removeInvalidCharacter((_f = values.managementGroupLevels) == null ? void 0 : _f.level3)
        )
      );
    }
    if (!!values.workspaceId) {
      expParams.push(getNameValuePair(this.WORKSPACEID_KEY, values.workspaceId));
    }
    let requestHeaders = {};
    requestHeaders[this.EXP_PARAMS_HEADER_KEY] = expParams.join(", ");
    requestHeaders[this.SDK_VERSION_HEADER_KEY] = this.SDK_VERSION_HEADER_VALUE;
    return requestHeaders;
  }
  removeInvalidCharacter(str) {
    if (!str) {
      return str;
    }
    return str.replace("–", "-");
  }
  getManagementGroupHeaders(userAlias, workspaceId, logger) {
    return __async(this, null, function* () {
      try {
        const result = yield UsersResource.getUserManagementGroupV2(
          userAlias,
          workspaceId,
          this.CHECK_MANAGEMENT_GROUP_TIMEOUT_IN_MS
        );
        if (result.isSuccessful()) {
          const data = result.getSuccessData();
          return getManagementGroupLevels(!!data ? data.ManagementGroup : "");
        }
      } catch (error) {
        logger == null ? void 0 : logger.log("Error occured when calling user management group endpoint ", { error });
      }
      return {
        level1: "",
        level2: "",
        level3: ""
      };
    });
  }
  isGroupMember(userAlias, logger) {
    return __async(this, null, function* () {
      let isAneGroupMember = TASService.isAnEGroupMember();
      if (typeof isAneGroupMember !== "boolean") {
        const isAneGroupMemberFromApi = yield this.checkAneGroupMember(userAlias, logger);
        if (isAneGroupMemberFromApi !== null) {
          TASService.setAnEGroupMember({ user: userAlias, isAneGroupMember: isAneGroupMemberFromApi });
        }
        isAneGroupMember = !!isAneGroupMemberFromApi;
      }
      if (isAneGroupMember && !HostService.isAne) {
        HostResource.setIsAne();
      }
      return isAneGroupMember;
    });
  }
  checkAneGroupMember(userAlias, logger) {
    return __async(this, null, function* () {
      let isAneTeamMember = false;
      try {
        isAneTeamMember = yield graphService.checkMemberGroupsWithTimeout(
          userAlias + this.ALIAS_EMAIL_SUFFIX,
          ANE_GROUP_ID,
          this.CHECK_GROUP_TIMEOUT_IN_MS
        );
      } catch (error) {
        logger == null ? void 0 : logger.log("Error occured when calling ane security group check ", { error });
        return new Promise((resolve) => {
          resolve(null);
        });
      }
      return isAneTeamMember;
    });
  }
};
__decorateClass([
  onError({ message: `An error occurred while getting the user's assigned treatments. ${continuationErrorMessage}` })
], TreatmentAssignmentResource.prototype, "getTreatmentAssignment", 1);
TreatmentAssignmentResource = __decorateClass([
  WPSProxyConverter(),
  expAdapterService()
], TreatmentAssignmentResource);
const TreatmentAssignmentResource$1 = new TreatmentAssignmentResource();
export {
  TreatmentAssignmentResource,
  TreatmentAssignmentResource$1 as default
};
//# sourceMappingURL=TreatmentAssignmentResource.js.map
